import React from 'react';
import { cn } from '../index';

export interface AvatarProps {
  name: string;
  src?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-9 w-9 text-sm',
  lg: 'h-12 w-12 text-lg',
};

export const Avatar: React.FC<AvatarProps> = ({ name, src, size = 'md', className }) => {
  const initials = name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className={cn('rounded-full object-cover', sizeMap[size], className)}
      />
    );
  }

  return (
    <div
      className={cn(
        'rounded-full bg-[var(--primary)] text-[var(--primary-fg)] flex items-center justify-center font-medium flex-shrink-0',
        sizeMap[size],
        className,
      )}
      aria-label={name}
    >
      {initials}
    </div>
  );
};
